export const openErrorNotification = (
  errorText = 'Sorry, something went wrong.',
  buttonText = 'Try sending it again',
  isError = true
) => {
  const notifcationWrapper = document.querySelector('.notification')
  const notifcationText = notifcationWrapper.querySelector('.notification-text')
  const notifcationButton = notifcationWrapper.querySelector('.notification-button')

  if (notifcationWrapper) {
    notifcationText.textContent = errorText
    notifcationButton.textContent = buttonText

    if (isError) {
      notifcationWrapper.classList.add('error')
    } else {
      notifcationWrapper.classList.remove('error')
    }

    notifcationWrapper.style.display = 'flex'
    setTimeout(() => {
      notifcationWrapper.style.opacity = 1
    }, 300)

    setTimeout(() => {
      notifcationWrapper.style.opacity = 0
      setTimeout(() => {
        notifcationWrapper.style.display = 'none'
      }, 300)
    }, 5000)
  }
}
